<script lang="ts">

    export let size = 10;
    export let color = '#000000';

</script>

<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size * 2.4286} viewBox="0 0 13.166 31.975">
    <g transform="translate(-104.959 -624.918)">
        <path fill={color} d="M115.676,636.072V656.1h2.449v.788H105.134V656.1h2.406V636.859h-2.581v-.787Zm-3.937-11.154c2.712,0,4.331,1.356,4.331,4.024,0,2.318-1.269,4.112-4.418,4.112-3.543,0-4.375-2.231-4.375-4.068C107.277,626.843,108.458,624.918,111.739,624.918Z" />
    </g>
</svg>
  